import { queryClient } from '@/lib/queryClient'
import type { LoginResponse } from '@/services/auth'
import { STORAGE_KEYS } from '@/utils/storageKeys'

const SESSION_KEY = STORAGE_KEYS.AUTH_SESSION

export const useAuth = () => {
  const getSession = (): LoginResponse | null => {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    try {
      return JSON.parse(raw) as LoginResponse
    } catch {
      return null
    }
  }

  const setSession = (session: LoginResponse) => {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  }

  const clearSession = () => {
    localStorage.removeItem(SESSION_KEY)
    queryClient.clear()
  }

  const isAuthenticated = () => Boolean(getSession()?.access_token)

  return { getSession, setSession, clearSession, isAuthenticated }
}
